import * as React from "react";
const SvgFiRrHeadSideHeadphones = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-head-side-headphones_svg__a)">
      <path
        fill="#062147"
        d="M19.802 4.419C17.362 1.164 13.489-.45 9.453.106 4.457.793.501 4.946.046 9.982c-.25 2.77.536 5.501 2.215 7.691.477.624.74 1.46.74 2.355v.971c0 1.654 1.345 3 3 3h7c1.654 0 3-1.346 3-3h.493a5.015 5.015 0 0 0 4.958-4.345l.218-1.655H22c1.3 0 2-1.03 2-2 0-1.42-2.931-7.013-4.198-8.58M11 9c1.103 0 2 .897 2 2s-.897 2-2 2c-1.104 0-2-.897-2-2s.896-2 2-2m9.794 4a1 1 0 0 0-.992.869l-.334 2.523a3.01 3.01 0 0 1-2.975 2.607h-1.493a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-.971c0-1.332-.41-2.601-1.152-3.571a9 9 0 0 1-1.81-6.296c.371-4.118 3.603-7.514 7.686-8.074a9 9 0 0 1 .276-.034v5.072a4.006 4.006 0 0 0-3 3.874c0 2.206 1.793 4 4 4s4-1.794 4-4a4.006 4.006 0 0 0-3-3.874V2.054c2.448.268 4.673 1.526 6.223 3.594 1.306 1.616 3.65 6.453 3.774 7.353z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-head-side-headphones_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrHeadSideHeadphones;
